export default __webpack_public_path__ + "static/media/profile-image.7a30cf55.jpg";